// components/MouvementFinancier/components/MouvementTableRow.jsx
import { Badge } from "react-bootstrap";
import { formatAmountInThousands, formatDate } from "../../service/utils/formatters";
import {  getCategorieClass } from "../../service/utils/mouvementFinancierUtils";
import { formatAmount } from '../../service/utils/orderUtils';
import { FaEye, FaFile } from "react-icons/fa";
import { PropTypes } from 'prop-types';

/**
 * LIGNE DE TABLEAU MOUVEMENT FINANCIER
 * Affiche une ligne complète avec toutes les informations
 */
const MouvementTableRow = ({ mouvement, onViewDocument, isOffline }) => {

  const hasDocument = mouvement.hasDocument || mouvement.preuveCash;
  return (
    <tr className="align-middle border-bottom">
      {/* Compte */}
      <td>
        <div className="d-flex align-items-center">
          <div className="avatar-sm bg-primary bg-opacity-10 rounded-circle me-3">
            <span className="avatar-title text-black fw-bold">
              {mouvement.accountName?.charAt(0)?.toUpperCase() || 'C'}
            </span>
          </div>
          <div>
            <h6 className="mb-0 fw-semibold">{mouvement.accountName}</h6>
            {/* <small className="text-muted">Ref: {facturation.id}</small> */}
          </div>
        </div>
      </td>

      {/* Catégorie */}
      <td>
        <span className={`badge rounded-pill px-3 py-2 ${getCategorieClass(mouvement.categorie)}`}>
          {mouvement.categorie}
        </span>
      </td>

      {/* Quantité */}
      <td className="text-end">
        {mouvement.quantity && mouvement.quantity > 0 ? (
          <div className="fw-bold text-primary">
            {formatAmount(mouvement.quantity)}
          </div>
        ) : (
          <span className="text-muted">N/A</span>
        )}
      </td>


      {/* Valeur */}
      <td className="text-end">
        {mouvement.lastValue && mouvement.lastValue > 0 ? (
          <div className="fw-bold text-success">
            {formatAmount(mouvement.lastValue)}
          </div>
        ) : (
          <span className="text-muted">N/A</span>
        )}
      </td>


       {/* libelle */}
      <td className="text-end">
          <Badge 
            bg={mouvement.libelle == 'Debit' ? "bg-success rounded-pill bg-opacity-10 text-success border border-success border-opacity-25" : "bg-danger rounded-pill bg-opacity-10 text-danger border border-danger border-opacity-25"}
            className="fw-semibold"
          >
            {mouvement.libelle}
          </Badge>
      </td>

      {/* Retenu Impôt */}
      <td className="text-end">
        {mouvement.retenuImpot && mouvement.retenuImpot > 0 ? (
          <div className="fw-medium text-danger">
            {formatAmountInThousands(mouvement.retenuImpot)}
          </div>
        ) : (
          <span className="text-muted">N/A</span>
        )}
      </td>


      {/* Description */}
      <td>
        <div className="text-dark">{mouvement.descriptif}</div>
        {mouvement.securityName && (
          <small className="text-muted">Titre: {mouvement.securityName}</small>
        )}
      </td>

      {/* Date */}
      <td className="text-nowrap">
        <div className="fw-medium text-dark">
          {formatDate(mouvement.date)}
        </div>
      </td>

      {/* Colonne Actions/Doc */}
      <td className="text-center">
        <div className="d-flex justify-content-center gap-2">
          {hasDocument ? (
            <>
              <button
                className={`btn btn-sm ${isOffline ? 'btn-outline-secondary disabled' : 'btn-outline-primary'}`}
                onClick={() => !isOffline && onViewDocument(mouvement)}
                disabled={isOffline}
                title={isOffline ? "Indisponible hors ligne" : "Voir le document"}
              >
                <FaEye size={12} />
              </button>
            </>
          ) : (
            <span className="badge bg-secondary bg-opacity-10 text-secondary">
              <FaFile size={12} />
            </span>
          )}
        </div>
      </td>
    </tr>
  );
};

MouvementTableRow.propTypes = {
  // No prop types defined
  mouvement : PropTypes.object,
  onViewDocument : PropTypes.func,
  isOffline : PropTypes.bool
};

export default MouvementTableRow;